import type { Clipboard } from "environment-interface/clipboard";

export const createClipboard = (): Clipboard => {
  return {
    write: (text) => navigator.clipboard.writeText(text),
  };
};
